import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Grid,
  IconButton,
  Loader,
  Message,
  Notification,
  Panel,
  Row,
  SelectPicker,
  Stack
} from 'rsuite';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
import CollaspedOutlineIcon from '@rsuite/icons/CollaspedOutline';
import { useLocation, useNavigate } from 'react-router-dom';
import globalIP from '@/GlobelIP';
import { handleDecrypt } from '@/functions';
import { useInView } from 'react-intersection-observer';
import useLabel from './hook/Label';
import axios from 'axios';
import pptxgen from 'pptxgenjs';
import FilterDrawer from './FilterDrawer';
import product from './wasteImages/product.jpg';
import './HomePages/home.css';
import SortUpIcon from '@rsuite/icons/SortUp';
import ImageIcon from '@rsuite/icons/Image';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import fontImages from '../pages/catalogue/MetalExport1.jpg';
import ReloadIcon from '@rsuite/icons/Reload';
import ProductModal from './ProductModal';
import SmartSearchModal from './smart-search-modal';
import RandomIcon from '@rsuite/icons/Random';
import { useSelectedProducts } from '@/store/QuerySelectred';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import ProductGridView from './ProductGridView';
import ProductTableView from './ProductTableView';
import MobileFilterDrawer from './MobileFilterDrawer';
import ugr from '@/UGRoute';
export default function Products() {
  const ip = globalIP;
  // const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const con = searchParams.get('conid');

  const condition = Number(con);
  let C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id'));
  let catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
  let cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));

  const handlecheck = () => {
    if (condition == 1) {
      C_A_id = handleDecrypt(searchParams.get('Calid'));
      catalogueCode = handleDecrypt(searchParams.get('etype'));
      cltCode = handleDecrypt(searchParams.get('cli'));
    } else {
      C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id')); //C_A_id (Client Activity id)
      catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
      cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));
    }
  };
  useEffect(() => {
    if (searchParams || sessionStorage.getItem('E-C_A_id')) {
      handlecheck();
    }
  }, [searchParams, sessionStorage.getItem('E-C_A_id')]);
  // const C_A_id = handleDecrypt(searchParams.get('Calid'));
  // const catalogueCode = handleDecrypt(searchParams.get('etype'));
  // const cltCode = handleDecrypt(searchParams.get('cli'));

  // const C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id')); //C_A_id (Client Activity id)
  // const catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
  // const cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));

  // let C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id')); //C_A_id (Client Activity id)
  // let catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
  // let cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));

  // useEffect(() => {
  //   if (companydata) {
  //     if (companydata == 'Domestic') {
  //       C_A_id = handleDecrypt(searchParams.get('Calid')); //C_A_id (Client Activity id)
  //       catalogueCode = handleDecrypt(searchParams.get('etype'));
  //       cltCode = handleDecrypt(searchParams.get('cli'));
  //     } else {
  //       C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id')); //C_A_id (Client Activity id)
  //       catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
  //       cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));
  //     }
  //   }
  // }, [companydata]);

  const navigate = useNavigate();
  const [cata, setCata] = useState([]);
  const [matchingProductIds, setMatchingProductIds] = useState([]);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modelData, setModelData] = useState([]);
  const [allQyeryData, setAllQyeryData] = useState([]);
  const [allProductData, setAllProductData] = useState([]);
  const [dataGrid, setDataGrid] = useState(8);
  const [dataGrid2, setDataGrid2] = useState(6);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [limit, setLimit] = useState(0);
  const [smartSerachModalOpen, setSmartSerachModalOpen] = useState(false);
  const [stopInfininitescrol, setStopInfininitescrol] = useState(true);
  const [isLoadingPPTDownload, setIsLoadingPPTDownload] = useState(false);
  const [expendFilter, setExpendFilter] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredID, setIsHoveredID] = useState();
  const [attributesData, setAttributesData] = useState({});
  const [showTabs, setShowTabs] = useState(2);
  const {
    selectedItems,
    handleCheckChange,
    isSelectedLoading,
    handleCleanSelectedItems,
    handleSelectAllIds
  } = useSelectedProducts();

  const [data1, setData1] = useState([]);
  const [isShowButtons, setIsShowButtons] = useState({
    ppt: false,
    filter: false,
    slideShow: true,
    SmartSearch: false
  });
  const [selectFieldData, setSelectFieldData] = useState({
    Category: [],
    Type: [],
    Color: [],
    Product_Name: [],
    Buyer_Style: [],
    Finish: [],
    Alias_Code: [],
    Search_keyword: []
  });
  const [selectedFieldValue, setSelectedFieldValue] = useState({
    Category: [],
    Type: [],
    Color: [],
    Product_Name: [],
    Buyer_Style: [],
    Finish: [],
    Alias_Code: [],
    Search_keyword: []
  });
  const clearSelectedFields = () => {
    setSelectedFieldValue({
      Category: [],
      Type: [],
      Color: [],
      Product_Name: [],
      Buyer_Style: [],
      Finish: [],
      Alias_Code: [],
      Search_keyword: []
    });
  };
  const { ref, inView } = useInView({
    rootMargin: `0px 0px 600px 0px`
  });
  const { attributesName } = useLabel();
  useEffect(() => {
    const fetchDatacata = async () => {
      if (catalogueCode) {
        const response = await fetch(
          `${ip}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${catalogueCode}`
        );
        const json = await response.json();
        setCata(json.data);
      }
    };
    fetchDatacata();
  }, [catalogueCode, ip]);

  useEffect(() => {
    if (cata.length) {
      setAttributesData({
        Cust_Aliascode: cata[0].attributes.Cust_Aliascode,
        Cust_CBM: cata[0].attributes.Cust_CBM,
        Cust_Category: cata[0].attributes.Cust_Category,
        Cust_Color: cata[0].attributes.Cust_Color,
        Cust_Description: cata[0].attributes.Cust_Description,
        Cust_Finish: cata[0].attributes.Cust_Finish,
        Cust_FreeSize: cata[0].attributes.Cust_FreeSize,
        Cust_GrsWgt: cata[0].attributes.Cust_GrsWgt,
        Cust_NetWgt: cata[0].attributes.Cust_NetWgt,
        Cust_Productname: cata[0].attributes.Cust_Productname,
        Cust_Producttype: cata[0].attributes.Cust_Producttype,
        Cust_SalePrice: cata[0].attributes.Cust_SalePrice,
        Cust_Unit: cata[0].attributes.Cust_Unit
      });
    }
  }, [cata[0]]);
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          data: { attributes }
        }
      } = await axios.get(
        `${globalIP}/api/client-logins/${sessionStorage.getItem('user_id')}?populate=*`
      );
      setIsShowButtons(prev => ({
        ppt: attributes.downloadppt,
        filter: attributes.showfilter,
        slideShow: attributes.SlideShow == null || attributes.SlideShow == false ? false : true,
        SmartSearch:
          attributes.SmartSearch == null || attributes.SmartSearch == false ? false : true
      }));
    };
    fetchData();
  }, []);
  const [storeAllImagePath, setStoreAllImagePath] = useState([]);
  useEffect(() => {
    const allCatalogProducts = cata.flatMap(item =>
      item.attributes.CatalogueProduct.map(product => product.CatalogProduct)
    );
    const pageIds = allCatalogProducts.map(id => parseInt(id, 10));
    setMatchingProductIds(pageIds);
  }, [cata]);

  useEffect(() => {
    const fetchAllData = async () => {
      if (matchingProductIds.length) {
        const pageSize = 25;
        const totalPages = Math.ceil(matchingProductIds.length / pageSize);
        const allData = [];
        const categorySet = new Set();
        const productTypeNameSet = new Set();
        const productNameSet = new Set();
        const colorSet = new Set();
        const buyerSet = new Set();
        const productIdSet = new Set();
        const searchKeywordSet = new Set();
        const FinishSet = new Set();
        for (let page = 1; page <= totalPages; page++) {
          const startIndex = (page - 1) * pageSize;
          const endIndex = Math.min(startIndex + pageSize, matchingProductIds.length);
          const pageIds = matchingProductIds.slice(startIndex, endIndex);
          // console.log('pageIds');
          // console.log(pageIds);
          const ids = pageIds.map(id => `filters[id][$in][]=${id}`).join('&');
          const { data } = await axios.get(`${ip}/api/products?${ids}&populate=*`);
          allData.push(...data.data);
          data.data.forEach(item => {
            if (item.attributes.CategoryName && item.attributes.CategoryCode) {
              const category = {
                label: item.attributes.CategoryName,
                value: item.attributes.CategoryCode
              };
              const categoryString = JSON.stringify(category);
              if (!categorySet.has(categoryString)) {
                categorySet.add(categoryString);
              }
            }
            if (item.attributes.ProductTypeName && item.attributes.ProductTypeCode) {
              const prtypr = {
                label: item.attributes.ProductTypeName,
                value: item.attributes.ProductTypeCode
              };
              const productTypeNameString = JSON.stringify(prtypr);
              if (!productTypeNameSet.has(productTypeNameString)) {
                productTypeNameSet.add(productTypeNameString);
              }
            }
            if (item.attributes.ProductName && item.attributes.ProductName) {
              const productName = {
                label: item.attributes.ProductName,
                value: item.attributes.ProductName
              };
              const productNameString = JSON.stringify(productName);
              if (!productNameSet.has(productNameString)) {
                productNameSet.add(productNameString);
              }
            }
            if (item.attributes.ColorName && item.attributes.ColorCode) {
              const color = {
                label: item.attributes.ColorName,
                value: item.attributes.ColorCode
              };
              const colorString = JSON.stringify(color);
              if (!colorSet.has(colorString)) {
                colorSet.add(colorString);
              }
            }
            if (item.attributes.BuyerSku && item.attributes.BuyerSku) {
              const buyer = {
                label: item.attributes.BuyerSku,
                value: item.attributes.BuyerSku
              };
              const buyerString = JSON.stringify(buyer);
              if (!buyerSet.has(buyerString)) {
                buyerSet.add(buyerString);
              }
            }
            if (item.attributes.ProductId && item.attributes.ProductId) {
              const ProductId = {
                label: item.attributes.ProductId,
                value: item.attributes.ProductId
              };
              const ProductIdString = JSON.stringify(ProductId);
              if (!productIdSet.has(ProductIdString)) {
                productIdSet.add(ProductIdString);
              }
            }
            if (item.attributes.SearchKeyword && item.attributes.SearchKeyword) {
              const SearchKeyword = {
                label: item.attributes.SearchKeyword,
                value: item.attributes.SearchKeyword
              };
              const SearchKeywordString = JSON.stringify(SearchKeyword);
              if (!searchKeywordSet.has(SearchKeywordString)) {
                searchKeywordSet.add(SearchKeywordString);
              }
            }
            if (item.attributes.FinishName && item.attributes.FinishName) {
              const Finish = {
                label: item.attributes.FinishName,
                value: item.attributes.FinishCode
              };
              const FinishString = JSON.stringify(Finish);
              if (!FinishSet.has(FinishString)) {
                FinishSet.add(FinishString);
              }
            }
          });
        }
        const category = Array.from(categorySet).map(categoryString => JSON.parse(categoryString));
        const productypeName = Array.from(productTypeNameSet).map(productTypeNameString =>
          JSON.parse(productTypeNameString)
        );
        const producteName = Array.from(productNameSet).map(productNameSet =>
          JSON.parse(productNameSet)
        );
        const color = Array.from(colorSet).map(colorSet => JSON.parse(colorSet));
        const BuyerStyle = Array.from(buyerSet).map(buyerSet => JSON.parse(buyerSet));
        const productId = Array.from(productIdSet).map(productIdSet => JSON.parse(productIdSet));
        const searchKeyword = Array.from(searchKeywordSet).map(searchKeywordSet =>
          JSON.parse(searchKeywordSet)
        );
        const Finish = Array.from(FinishSet).map(FinishSet => JSON.parse(FinishSet));
        const imagePath = allData.map(item => {
          if (item.attributes.CoverImage.data) {
            return {
              id: item.id,
              path: `${item.attributes.CoverImage.data.attributes.url}`
            };
          }
        });
        setStoreAllImagePath(imagePath);
        setAllProductData(allData);
        setSelectFieldData(prev => ({
          ...prev,
          Category: category,
          Type: productypeName,
          Product_Name: producteName,
          Color: color,
          Buyer_Style: BuyerStyle,
          Alias_Code: productId,
          Search_keyword: searchKeyword,
          Finish
        }));
      }
    };

    fetchAllData();
  }, [matchingProductIds]);

  useEffect(() => {
    const fetchNextBatch = async () => {
      if (inView && limit && matchingProductIds.length > 25 && stopInfininitescrol) {
        setLoading(true);
        try {
          const slicedIds = matchingProductIds.slice(startIndex, endIndex);
          if (slicedIds.length) {
            const productIdsQueryParam = slicedIds.map(id => `filters[id][$in][]=${id}`).join('&');
            const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
            const response = await fetch(apiUrl);
            const json = await response.json();
            setLimit(json.data.length);
            setFetchedProducts(prev => [...prev, ...json.data]);
            setStartIndex(prevIndex => prevIndex + 25);
            setEndIndex(prevIndex => prevIndex + 25);
          } else {
            setLimit(0);
          }
        } catch (error) {
          console.error('Error fetching next batch of products:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchNextBatch();
  }, [inView]);
  const [refechData, setRefechData] = useState(false);
  useEffect(() => {
    const fetchProducts = async matchingIds => {
      setLoading(true);
      try {
        const productIdsQueryParam = matchingIds.map(id => `filters[id][$in][]=${id}`).join('&');
        const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
        const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*`;
        const response = await fetch(apiUrl);
        const response1 = await fetch(apiUrl1);
        const json = await response.json();
        const json1 = await response1.json();
        setFetchedProducts(prev => [...prev, ...json.data, ...json1.data]);
        setStartIndex(25);
        setEndIndex(50);
        setLimit(json.data.length);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    if (matchingProductIds.length > 0) {
      const slicedData = matchingProductIds.slice(0, 25);
      fetchProducts(slicedData);
    } else {
      setFetchedProducts([]);
    }
  }, [matchingProductIds]);
  useEffect(() => {
    const fetchProducts = async matchingIds => {
      setLoading(true);
      try {
        const productIdsQueryParam = matchingIds.map(id => `filters[id][$in][]=${id}`).join('&');
        const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
        const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*`;
        const response = await fetch(apiUrl);
        const response1 = await fetch(apiUrl1);
        const json = await response.json();
        const json1 = await response1.json();
        const alldata = [...json.data, ...json1.data]
        setFetchedProducts(alldata);
        setLimit(json.data.length);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    if (matchingProductIds.length > 0) {
      const slicedData = matchingProductIds.slice(0, 25);
      fetchProducts(slicedData);
    } else {
      setFetchedProducts([]);
    }
  }, [refechData]);

  const fetchDatam = async id => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${ip}/api/products?populate=*&filters[id][$eq]=${id}`);
      const response1 = await fetch(`${ip}/api/variant-products?populate=*&filters[id][$eq]=${id}`);
      // console.log('idddddddd', id);

      const json = await response.json();
      const json1 = await response1.json();
      const alldata = [...json.data, ...json1.data]
      setModelData(alldata);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = prdcd => {
    // console.log('prdcd');
    // console.log(prdcd);
    fetchDatam(prdcd);
    setOpen(true);
  };

  const handleChange = (key, value) => {
    setSelectedFieldValue(prev => ({
      ...prev,
      [key]: value
    }));
  };
  useEffect(() => {
    const fetchData = async () => {
      const email = sessionStorage.getItem('loginemail');
      const mobile = sessionStorage.getItem('loginmobile');
      const userName = sessionStorage.getItem('loginusername');
      if (email && mobile) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginmobile][$eq]=${mobile}&filters[loginusername][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      } else if (email && userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginusername][$eq]=${userName}&filters[loginmobile][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      } else if (userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$null]=true&filters[loginmobile][$null]=true&filters[loginusername][$eq]=${userName}`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      }
    };

    fetchData();
  }, [open]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };
  const handleDownloadPPT1 = () => {
    const ppt = new pptxgen();
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6,
        fill: '#eff1f0'
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%',
        h: 0.5,
        fill: '#2f7a7c'
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%',
        h: 0.5,
        fill: '#afafaf'
      };
      slide.addShape('rect', headerBackground2);

      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: 5.6
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
    };
    addIntroductionSlide();
    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const slideBackgroundColor = {
        x: 0.15,
        y: 0.1,
        w: '55%',
        h: '95.5%',
        fill: '#E5E4E2'
      };

      slide.addShape('rect', slideBackgroundColor);
      const slideBackgroundColorc = {
        x: 6,
        y: 0.1,
        w: '38%',
        h: '40%',
        fill: '#E5E4E2'
      };

      slide.addShape('rect', slideBackgroundColorc);
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.6,
        y: 0.25,
        w: 4.5,
        h: 5
      };
      try {
        slide.addImage({ path: imageUrl, ...imageOptions });
      } catch (e) {
        console.log('Error', e);
      }

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 3;
        const imageHeight = 2;
        const xOffset = 6.4;
        const yOffset = 0.2;

        const maxImages = Math.min(1, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          try {
            const img = multipleImages[index];
            const imageUrl = `${ip}${img.attributes.url}`;
            const imageOptions = {
              x: xOffset,
              y: yOffset,
              w: imageWidth,
              h: imageHeight
            };
            slide.addImage({ path: imageUrl, ...imageOptions });
          } catch (e) {
            console.log(e, 'jjjjjjjjjjjjjjj');
          }
        }
      }
      const tableRows = [];
      let yOffset = 0.1;

      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: attributesName?.AliasCode,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: attributesName?.ProductName,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `${':'}${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: attributesName?.ProductType,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${':'}${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: attributesName?.Description,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'top'
          }
        };
        const discValCell = {
          text: `${':'}${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `${':'}${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: attributesName?.finish,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `${':'}${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: attributesName?.SalePrice,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `${':'}${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: attributesName?.NetWgt,
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${':'}${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 5.9,
        y: 2.4,
        w: '40%',
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: false
      };

      slide.addTable(tableRows, tableOptions);
    };
    const reversedCata = [...allProductData].reverse();
    let serialCounter = 1;
    setIsLoadingPPTDownload(true);
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });
    ppt
      .writeFile({ fileName: 'Catalogue.pptx' })
      .then(res => {
        // console.log(res);
        setIsLoadingPPTDownload(false);
      })
      .catch(err => {
        setIsLoadingPPTDownload(false);

        console.log('Download PPT Error', err);
      });
  };
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 1) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const isAnyFieldSelected = Object.values(selectedFieldValue).every(field => field.length == 0);

  const handleHover = id => {
    setIsHovered(true);
    setIsHoveredID(id);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsHoveredID('');
  };
  const [mobileFilterOption, setmMbileFilterOption] = useState(false);
  const dataaaaa = [
    { label: 'Small', value: 6 },
    { label: 'Large', value: 8 }
  ];
  const dataaaaaa = [
    { label: 'Extra Small', value: 4 },
    { label: 'Small', value: 6 },
    { label: 'Large', value: 8 }
  ];
  let productData = [];
  if (showTabs == 2) {
    productData = (!isAnyFieldSelected ? allProductData : fetchedProducts).filter(item => {
      return (
        (selectedFieldValue.Category.length === 0 &&
          selectedFieldValue.Type.length === 0 &&
          selectedFieldValue.Color.length === 0 &&
          selectedFieldValue.Product_Name.length === 0 &&
          selectedFieldValue.Buyer_Style.length === 0 &&
          selectedFieldValue.Finish.length === 0 &&
          selectedFieldValue.Alias_Code.length === 0 &&
          selectedFieldValue.Search_keyword.length === 0) ||
        selectedFieldValue.Category.includes(item.attributes.CategoryCode) ||
        selectedFieldValue.Type.includes(item.attributes.ProductTypeCode) ||
        selectedFieldValue.Color.includes(item.attributes.ColorCode) ||
        selectedFieldValue.Product_Name.includes(item.attributes.ProductName) ||
        selectedFieldValue.Buyer_Style.includes(item.attributes.BuyerSku) ||
        selectedFieldValue.Finish.includes(item.attributes.FinishCode) ||
        selectedFieldValue.Alias_Code.includes(item.attributes.ProductId) ||
        selectedFieldValue.Search_keyword.includes(item.attributes.SearchKeyword)
      );
    });
  } else {
    productData = (!isAnyFieldSelected ? allProductData : fetchedProducts).filter(item => {
      return (
        (selectedFieldValue.Category.length === 0 &&
          selectedFieldValue.Type.length === 0 &&
          selectedFieldValue.Color.length === 0 &&
          selectedFieldValue.Product_Name.length === 0 &&
          selectedFieldValue.Buyer_Style.length === 0 &&
          selectedFieldValue.Finish.length === 0 &&
          selectedFieldValue.Alias_Code.length === 0 &&
          selectedFieldValue.Search_keyword.length === 0) ||
        selectedFieldValue.Category.includes(item.attributes.CategoryCode) ||
        selectedFieldValue.Type.includes(item.attributes.ProductTypeCode) ||
        selectedFieldValue.Color.includes(item.attributes.ColorCode) ||
        selectedFieldValue.Product_Name.includes(item.attributes.ProductName) ||
        selectedFieldValue.Buyer_Style.includes(item.attributes.BuyerSku) ||
        selectedFieldValue.Finish.includes(item.attributes.FinishCode) ||
        selectedFieldValue.Alias_Code.includes(item.attributes.ProductId) ||
        selectedFieldValue.Search_keyword.includes(item.attributes.SearchKeyword)
      );
    });
  }

  const [istouchBottom, setIstouchBottom] = useState(false);
  // console.log(`${globalIP}${data1[0]?.attributes?.Logo?.data?.attributes?.url}`);
  return (
    <main style={{ padding: '20px' }}>
      <Grid fluid>
        <Row gutter={10}>
          {condition == 1 ? (
            <Stack justifyContent="space-between" style={{ width: 'auto', marginBottom: '10px' }}>
              <b>{data1[0]?.attributes?.cmpnm}</b>
              <img
                src={`${globalIP}${data1[0]?.attributes?.Logo?.data?.attributes?.url}`}
                style={{ width: '40px' }}
              />
            </Stack>
          ) : null}
          <Col
            lg={isShowButtons.filter ? 4 : 24}
            style={{ marginBottom: '5px' }}
            className="product-hide-mobile"
          >
            {isShowButtons.filter && (
              <IconButton
                icon={expendFilter ? <CollaspedOutlineIcon /> : <ExpandOutlineIcon />}
                size="sm"
                onClick={() => setExpendFilter(prev => !prev)}
                style={{ background: '#005c80', color: 'white' }}
              />
            )}
            {condition == 1 ? null : (
              <>
                {isShowButtons.filter && (
                  <Checkbox
                    indeterminate={
                      selectedItems.length > 0 && selectedItems.length < fetchedProducts.length
                    }
                    checked={selectedItems.length === fetchedProducts.length}
                    onChange={value => handleSelectAllIds(allQyeryData, allProductData)}
                  >
                    Select all
                  </Checkbox>
                )}
              </>
            )}
            {!isShowButtons.filter && (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  {!isAnyFieldSelected ? (
                    <span
                      style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                      className="roboto-medium"
                    >
                      Founded: {productData.length}
                    </span>
                  ) : (
                    <span
                      style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                      className="roboto-medium"
                    >
                      Product: {productData.length}/{matchingProductIds.length}
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  {condition == 1 ? null : (
                    <>
                      {!isShowButtons.filter && (
                        <Checkbox
                          indeterminate={
                            selectedItems.length > 0 &&
                            selectedItems.length < fetchedProducts.length
                          }
                          checked={selectedItems.length === fetchedProducts.length}
                          onChange={value => handleSelectAllIds(allQyeryData, allProductData)}
                        >
                          Select all
                        </Checkbox>
                      )}
                    </>
                  )}
                  {expendFilter && isShowButtons.filter ? (
                    <SelectPicker
                      data={dataaaaa}
                      searchable={false}
                      style={{ width: 100 }}
                      value={dataGrid}
                      size="sm"
                      placeholder="Grid"
                      onChange={e => setDataGrid(!e ? 8 : e)}
                      cleanable={false}
                    />
                  ) : (
                    <SelectPicker
                      data={dataaaaaa}
                      searchable={false}
                      value={dataGrid2}
                      style={{ width: 100 }}
                      size="sm"
                      placeholder="Grid"
                      onChange={e => setDataGrid2(!e ? 6 : e)}
                      cleanable={false}
                    />
                  )}
                  {condition == 1 ? null : (
                    <>
                      {isShowButtons.filter && (
                        <Checkbox
                          indeterminate={
                            selectedItems.length > 0 &&
                            selectedItems.length < fetchedProducts.length
                          }
                          checked={selectedItems.length === fetchedProducts.length}
                          onChange={value => handleSelectAllIds(allQyeryData, allProductData)}
                        >
                          Select all
                        </Checkbox>
                      )}
                    </>
                  )}
                  {isShowButtons.SmartSearch && (
                    <IconButton
                      icon={<ImageIcon />}
                      size="sm"
                      onClick={() => {
                        setSmartSerachModalOpen(true);
                        setStopInfininitescrol(false);
                      }}
                    >
                      Smart Search
                    </IconButton>
                  )}
                  {isShowButtons.ppt && (
                    <IconButton
                      icon={<FileDownloadIcon />}
                      loading={isLoadingPPTDownload}
                      size="sm"
                      onClick={() => {
                        handleDownloadPPT1();
                      }}
                    >
                      Download PPT
                    </IconButton>
                  )}
                  {condition == 1 ? null : (
                    <>
                      {isShowButtons.slideShow && (
                        <IconButton
                          icon={<RandomIcon />}
                          size="sm"
                          onClick={() => {
                            navigate(`/${ugr}/client/slide-show`);
                          }}
                        >
                          Product Slide
                        </IconButton>
                      )}
                    </>
                  )}
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <IconButton
                      icon={<MenuIcon />}
                      active={showTabs == 1}
                      onClick={() => setShowTabs(1)}
                      className={
                        showTabs == 1 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                      }
                      id="bb"
                    />
                    <IconButton
                      icon={<GridIcon />}
                      active={showTabs == 2}
                      onClick={() => setShowTabs(2)}
                      className={
                        showTabs === 2 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                      }
                      id="bb"
                    />
                    <IconButton
                      // icon={<ReloadIcon className={isLoading && 'reload-products'} />}
                      icon={<ReloadIcon />}
                      size="sm"
                      style={{ backgroundColor: '#005c80', color: 'white' }}
                      onClick={() => {
                        setRefechData(prev => !prev);
                        setStartIndex(0);
                        setEndIndex(25);
                        clearSelectedFields();
                        handleCleanSelectedItems();
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </Col>
          {isShowButtons.filter && (
            <Col lg={20} style={{ marginBottom: '5px' }} className="product-hide-mobile">
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <div>
                  {!isAnyFieldSelected ? (
                    <p
                      style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                      className="roboto-medium"
                    >
                      Founded: {productData.length}
                    </p>
                  ) : (
                    <p
                      style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                      className="roboto-medium"
                    >
                      Product: {productData.length}/{matchingProductIds.length}
                    </p>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {expendFilter && isShowButtons.filter ? (
                    <SelectPicker
                      data={dataaaaa}
                      searchable={false}
                      style={{ width: 100 }}
                      size="sm"
                      value={dataGrid}
                      placeholder="Grid"
                      onChange={e => setDataGrid(!e ? 8 : e)}
                    />
                  ) : (
                    <SelectPicker
                      data={dataaaaaa}
                      searchable={false}
                      style={{ width: 100 }}
                      size="sm"
                      value={dataGrid2}
                      placeholder="Grid"
                      onChange={e => setDataGrid2(!e ? 6 : e)}
                    />
                  )}
                  {isShowButtons.SmartSearch && (
                    <IconButton
                      icon={<ImageIcon />}
                      size="sm"
                      onClick={() => {
                        setSmartSerachModalOpen(true);
                        setStopInfininitescrol(false);
                      }}
                    >
                      Smart Search
                    </IconButton>
                  )}
                  {isShowButtons.ppt && (
                    <IconButton
                      icon={<FileDownloadIcon />}
                      loading={isLoadingPPTDownload}
                      size="sm"
                      onClick={() => {
                        handleDownloadPPT1();
                      }}
                    >
                      Download PPT
                    </IconButton>
                  )}
                  {condition == 1 ? null : (
                    <>
                      {isShowButtons.slideShow && (
                        <IconButton
                          icon={<RandomIcon />}
                          size="sm"
                          onClick={() => {
                            navigate(`/${ugr}/client/slide-show`);
                          }}
                        >
                          Product Slide
                        </IconButton>
                      )}
                    </>
                  )}

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <IconButton
                      icon={<MenuIcon />}
                      active={showTabs == 1}
                      onClick={() => setShowTabs(1)}
                      size="sm"
                      className={
                        showTabs == 1 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                      }
                      id="bb"
                    />
                    <IconButton
                      icon={<GridIcon />}
                      active={showTabs == 2}
                      onClick={() => setShowTabs(2)}
                      size="sm"
                      className={
                        showTabs === 2 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                      }
                      id="bb"
                    />
                    <IconButton
                      icon={<ReloadIcon className={isLoading && 'reload-products'} />}
                      s
                      size="sm"
                      style={{ backgroundColor: '#005c80', color: 'white' }}
                      onClick={() => {
                        setRefechData(prev => !prev);
                        setStartIndex(0);
                        clearSelectedFields();
                        setEndIndex(25);
                        handleCleanSelectedItems();
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          )}
          {expendFilter && isShowButtons.filter && (
            <Col
              lg={4}
              style={{ position: 'sticky', top: '52px', borderTop: '1px solid lightGrey' }}
              className="product-hide-mobile"
            >
              <div style={{ paddingRight: '10px' }}>
                <FilterDrawer
                  selectFieldData={selectFieldData}
                  handleChange={handleChange}
                  selectedFieldValue={selectedFieldValue}
                  attributesName={attributesName}
                />
              </div>
            </Col>
          )}
          <Col xs={24} className="product-show-mobile" style={{ borderTop: '1px solid lightGrey' }}>
            <div style={{ padding: '10px 0', display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                {condition == 1 ? null : (
                  <>
                    {isShowButtons.slideShow && (
                      <IconButton
                        icon={<RandomIcon />}
                        size="sm"
                        onClick={() => {
                          navigate(`/${ugr}/client/slide-show`);
                        }}
                      >
                        Product Slide
                      </IconButton>
                    )}
                  </>
                )}
                <Button size="sm" onClick={() => setmMbileFilterOption(true)}>
                  More
                </Button>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <IconButton
                  icon={<MenuIcon />}
                  active={showTabs == 1}
                  onClick={() => setShowTabs(1)}
                  size="sm"
                  className={
                    showTabs == 1 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                  }
                  id="bb"
                />
                <IconButton
                  icon={<GridIcon />}
                  active={showTabs == 2}
                  onClick={() => setShowTabs(2)}
                  size="sm"
                  className={
                    showTabs === 2 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                  }
                  id="bb"
                />
                <IconButton
                  icon={<ReloadIcon className={isLoading && 'reload-products'} />}
                  size="sm"
                  style={{ backgroundColor: '#005c80', color: 'white' }}
                  onClick={() => {
                    setRefechData(prev => !prev);
                    setStartIndex(0);
                    clearSelectedFields();
                    setEndIndex(25);
                    handleCleanSelectedItems();
                  }}
                />
              </div>
            </div>
          </Col>
          <Col xs={24} className="product-show-mobile" style={{ borderTop: '1px solid lightGrey' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0'
              }}
            >
              <div>
                {!isAnyFieldSelected ? (
                  <p
                    style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                    className="roboto-medium"
                  >
                    Founded: {productData.length}
                  </p>
                ) : (
                  <p
                    style={{ padding: '10px 0px 10px 0', fontSize: '15px', fontWeight: 'bold' }}
                    className="roboto-medium"
                  >
                    Product: {productData.length}/{matchingProductIds.length}
                  </p>
                )}
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                {isShowButtons.SmartSearch && (
                  <IconButton
                    icon={<ImageIcon />}
                    size="sm"
                    onClick={() => {
                      setSmartSerachModalOpen(true);
                      setStopInfininitescrol(false);
                    }}
                  >
                    Search
                  </IconButton>
                )}
                {isShowButtons.ppt && (
                  <IconButton
                    icon={<FileDownloadIcon />}
                    loading={isLoadingPPTDownload}
                    size="sm"
                    onClick={() => {
                      handleDownloadPPT1();
                    }}
                  >
                    PPT
                  </IconButton>
                )}
              </div>
            </div>
          </Col>
          <Col
            lg={expendFilter && isShowButtons.filter ? 20 : 24}
            xs={24}
            className="product-grid-border"
          >
            {showTabs == 1 && (
              <Row>
                <Col xs={24}>
                  <ProductTableView
                    productData={productData}
                    allQyeryData={allQyeryData}
                    allProductData={allProductData}
                    fetchedProducts={fetchedProducts}
                    handleOpen={handleOpen}
                    istouchBottom={istouchBottom}
                    setIstouchBottom={setIstouchBottom}
                  />
                </Col>
              </Row>
            )}
            {showTabs == 2 && (
              <div style={{ padding: '0 0 0 10px' }}>
                <ProductGridView
                  productData={productData}
                  allQyeryData={allQyeryData}
                  expendFilter={expendFilter}
                  dataGrid={dataGrid}
                  dataGrid2={dataGrid2}
                  handleHover={handleHover}
                  handleMouseLeave={handleMouseLeave}
                  isHoveredID={isHoveredID}
                  isHovered={isHovered}
                  handleOpen={handleOpen}
                  handleCheckChange={handleCheckChange}
                  selectedItems={selectedItems}
                  isShowButton={isShowButtons}
                />
                {isAnyFieldSelected && <Button ref={ref} style={{ visibility: 'hidden' }}></Button>}
              </div>
            )}
          </Col>
        </Row>
      </Grid>
      {showButton && (
        <Stack justifyContent="flex-end">
          <IconButton
            size="sm"
            icon={<SortUpIcon />}
            active
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              top: '90%',
              right: 10,
              transform: 'translateY(-50%)',
              zIndex: 9999
            }}
          />
        </Stack>
      )}
      {selectedItems.length > 0 && (
        <Notification
          type="success"
          style={{
            position: 'fixed',
            top: '90%',
            right: 20,
            transform: 'translateY(-50%)',
            zIndex: 9999,
            background: '#005c80',
            color: 'white',
            width: 'auto'
          }}
        >
          <b style={{ color: 'white' }}>My Selected Products : {selectedItems.length}</b>
          <Divider vertical />
          <Button
            style={{ float: 'right', marginTop: '-7px' }}
            onClick={() =>
              navigate(`/${ugr}/client/buyers`, {
                state: {
                  selectedItems: selectedItems.join(','),
                  cltco: cltCode,
                  C_A_id: C_A_id
                }
              })
            }
            appearance="subtle"
            active
          >
            <b>Sent Query</b>
          </Button>
        </Notification>
      )}
      <MobileFilterDrawer
        selectFieldData={selectFieldData}
        handleChange={handleChange}
        selectedFieldValue={selectedFieldValue}
        attributesName={attributesName}
        open={mobileFilterOption}
        close={() => setmMbileFilterOption(false)}
      />
      {open && (
        <ProductModal
          modeldata={modelData}
          close={() => setOpen(false)}
          open={open}
          selectedItems={selectedItems}
          handleCheckboxChange={handleCheckChange}
          allQyeryData={allQyeryData}
          attributesData={attributesData}
          attributesName={attributesName}
        />
      )}
      {smartSerachModalOpen && (
        <SmartSearchModal
          open={smartSerachModalOpen}
          close={() => setSmartSerachModalOpen(false)}
          setStopInfininitescrol={setStopInfininitescrol}
          storeAllImagePath={storeAllImagePath}
          setFetchedProducts={setFetchedProducts}
        />
      )}
      {isSelectedLoading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0
          }}
          className="loading-bg"
        >
          <Loader size="lg" />
        </div>
      )}
      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '10px 20px',
          borderTop: '1px solid lightGrey',
          zIndex: 100,
          background: 'white'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          <a href="https://erpdaddy.com/" target="_blank" color="#005c80">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </main>
  );
}
